/* ==========================================================================
   NORATIV PDP — JAVASCRIPT
   Vervang het volledige oude bestand hiermee.

   Bevat:
   1. Gallery: thumbnails + pijlen
   2. Bundelkiezer
   3. Accordions
   4. Lab test modal
   5. Subscription toggle
   6. Video's
   7. Urgency countdown

   LET OP: dit bestand bevat uitsluitend JavaScript.
   Nooit CSS of HTML hierin plakken — dat geeft een syntax error
   waardoor alles hieronder stopt met werken.
   ========================================================================== */

(function () {
  'use strict';

  function formatMoney(amountCents) {
    return '$' + (amountCents / 100).toFixed(2);
  }

  /* ------------------------------------------------------------------
     1. GALLERY — thumbnails
     Scrollt op offsetLeft van de slide, niet op berekende breedte.
     Dat blijft kloppen ongeacht wat de CSS met de kolombreedte doet.
     ------------------------------------------------------------------ */
  function initGallery() {
    var thumbs = document.querySelectorAll('.norativ-thumb-item');
    var track = document.querySelector('.norativ-gallery-track');
    if (!thumbs.length || !track) return;

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        var slides = track.querySelectorAll('.norativ-gallery-slide');
        var target = slides[index];
        if (!target) return;

        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    });

    // Actieve thumb loopt mee bij swipen
    track.addEventListener('scroll', function () {
      var slides = track.querySelectorAll('.norativ-gallery-slide');
      var closest = 0;
      var min = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; closest = i; }
      });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (thumbs[closest]) thumbs[closest].classList.add('is-active');
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     1b. GALLERY — pijlen
     De rotatie van de linkerpijl zit in de CSS op de svg, niet op de
     knop: die heeft translateY nodig voor verticale centrering.
     ------------------------------------------------------------------ */
  function initGalleryArrows() {
    var container = document.querySelector('.norativ-gallery-container');
    if (!container) return;
    if (container.querySelector('.norativ-gallery-arrow')) return;

    var track = container.querySelector('.norativ-gallery-track');
    if (!track) return;

    var slides = track.querySelectorAll('.norativ-gallery-slide');
    if (slides.length < 2) return;

    var ARROW = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    function makeArrow(dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'norativ-gallery-arrow norativ-gallery-arrow--' + dir;
      btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      btn.innerHTML = ARROW;
      return btn;
    }

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    container.appendChild(prev);
    container.appendChild(next);

    function step(direction) {
      var list = track.querySelectorAll('.norativ-gallery-slide');
      var current = 0;
      var min = Infinity;
      list.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; current = i; }
      });
      var target = list[current + direction];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); step(1); });

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  /* ------------------------------------------------------------------
     2. BUNDELKIEZER
     ------------------------------------------------------------------ */
  function initBundlePicker() {
    var cards = document.querySelectorAll('.norativ-bundle-card');
    if (!cards.length) return;

    var variantInput = document.querySelector('input[name="id"]');
    var priceDisplay = document.querySelector('.norativ-price-current');
    var compareDisplay = document.querySelector('.norativ-price-compare');
    var badgeDisplay = document.querySelector('.norativ-price-badge');
    var atcPriceDisplay = document.querySelector('.norativ-atc-price');

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');

        var variantId = card.dataset.variantId;
        var priceText = card.dataset.priceText;
        var priceVal = parseFloat(card.dataset.priceVal || 0);
        var compareVal = parseFloat(card.dataset.compareVal || 0);

        if (variantInput && variantId) variantInput.value = variantId;
        if (priceDisplay && priceText) priceDisplay.textContent = priceText;
        if (atcPriceDisplay && priceText) atcPriceDisplay.textContent = priceText;

        if (compareVal > priceVal && compareVal > 0) {
          if (compareDisplay) {
            compareDisplay.style.display = 'inline-block';
            compareDisplay.textContent = formatMoney(compareVal);
          }
          if (badgeDisplay) {
            badgeDisplay.style.display = 'inline-block';
            badgeDisplay.textContent = 'Save ' + formatMoney(compareVal - priceVal);
          }
        } else {
          if (compareDisplay) compareDisplay.style.display = 'none';
          if (badgeDisplay) badgeDisplay.style.display = 'none';
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     3. ACCORDIONS
     ------------------------------------------------------------------ */
  function initAccordions() {
    var headers = document.querySelectorAll('.norativ-accordion-header, .norativ-faq-question');

    headers.forEach(function (header) {
      header.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var parent = header.closest('.norativ-accordion-item, .norativ-faq-card');
        if (!parent) return;

        var body = parent.querySelector('.norativ-accordion-body, .norativ-faq-answer');
        if (!body) return;

        if (parent.classList.contains('is-open')) {
          parent.classList.remove('is-open');
          body.style.height = '0px';
        } else {
          parent.classList.add('is-open');
          body.style.height = body.scrollHeight + 'px';
        }
      });
    });

    // Open panelen meelaten groeien bij resize
    window.addEventListener('resize', function () {
      document.querySelectorAll('.is-open').forEach(function (parent) {
        var body = parent.querySelector('.norativ-accordion-body, .norativ-faq-answer');
        if (body) body.style.height = body.scrollHeight + 'px';
      });
    });
  }

  /* ------------------------------------------------------------------
     4. LAB TEST MODAL
     ------------------------------------------------------------------ */
  function initLabTestModal() {
    var modal = document.querySelector('#NorativLabModal');
    if (!modal) return;

    var link = document.querySelector('.norativ-lab-test-link');
    var closeBtn = modal.querySelector('.norativ-modal-close');
    var iframe = modal.querySelector('iframe');

    function close() {
      modal.classList.remove('is-active');
      if (iframe) iframe.src = '';
      document.body.style.overflow = '';
    }

    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var href = link.getAttribute('href');
        if (href && href !== '#') {
          if (iframe) iframe.src = href;
        }
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) close();
    });
  }

  /* ------------------------------------------------------------------
     5. SUBSCRIPTION TOGGLE (alleen visuele staat)
     ------------------------------------------------------------------ */
  function initSubscriptionToggle() {
    var toggleBtns = document.querySelectorAll('.norativ-upsell-toggle-btn');
    if (!toggleBtns.length) return;

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ------------------------------------------------------------------
     6. VIDEO'S
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     6. VIDEO'S
     BEWUST LEEG. De ugc_video_slider sectie in norativ-product-page.liquid
     heeft een eigen inline script dat play/pause, tijdweergave en mute
     afhandelt. Toen hier ook listeners hingen, vuurde elke klik op de
     play-knop twee keer: play() gevolgd door pause(), waardoor er niets
     gebeurde. Niet opnieuw toevoegen zonder de liquid-versie te slopen.
     ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     INIT
     ------------------------------------------------------------------ */
  function initAll() {
    initGallery();
    initGalleryArrows();
    initBundlePicker();
    initAccordions();
    initLabTestModal();
    initSubscriptionToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();


/* ==========================================================================
   7. URGENCY COUNTDOWN
   Telt af naar de verzendcutoff van vandaag. Is die gepasseerd, dan naar
   de cutoff van morgen. Eén interval voor alle timers op de pagina.
   ========================================================================== */

(function () {
  'use strict';

  var timers = [];
  var ticking = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function nextCutoff(hour, minute) {
    var now = new Date();
    var target = new Date(
      now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0
    );
    if (target.getTime() <= now.getTime()) {
      target.setDate(target.getDate() + 1);
    }
    return target;
  }

  function render(timer) {
    var diff = timer.target.getTime() - Date.now();

    if (diff <= 0) {
      timer.target = nextCutoff(timer.hour, timer.minute);
      diff = timer.target.getTime() - Date.now();
    }

    var total = Math.floor(diff / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;

    // Precies op de cutoff-seconde zou h op 24 uitkomen; klem dat af
    if (h > 23) { h = 23; m = 59; s = 59; }

    if (timer.h && timer.h.textContent !== pad(h)) timer.h.textContent = pad(h);
    if (timer.m && timer.m.textContent !== pad(m)) timer.m.textContent = pad(m);
    if (timer.s && timer.s.textContent !== pad(s)) timer.s.textContent = pad(s);

    if (timer.el.getAttribute('data-ready') !== 'true') {
      timer.el.setAttribute('data-ready', 'true');
    }
  }

  function tick() {
    for (var i = 0; i < timers.length; i++) render(timers[i]);
  }

  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-norativ-countdown]');
    if (!nodes.length) return;

    timers = [];

    Array.prototype.forEach.call(nodes, function (el) {
      var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
      var minute = parseInt(el.getAttribute('data-cutoff-minute'), 10);
      if (isNaN(hour)) hour = 16;
      if (isNaN(minute)) minute = 0;

      timers.push({
        el: el,
        hour: hour,
        minute: minute,
        target: nextCutoff(hour, minute),
        h: el.querySelector('[data-unit="hours"]'),
        m: el.querySelector('[data-unit="minutes"]'),
        s: el.querySelector('[data-unit="seconds"]')
      });
    });

    tick();

    if (ticking) clearInterval(ticking);
    ticking = setInterval(tick, 1000);
  }

  // Bij terugkeer uit een achtergrondtab meteen bijwerken
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCountdowns);
  }
})();


/* ==========================================================================
   8. NIEUWE SECTIES — INTERACTIE
   Sticky ATC, tabs, benefits accordion, results carousel, live viewers.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     8.1 STICKY ADD TO CART
     Verschijnt zodra de hoofdknop uit beeld is. IntersectionObserver in
     plaats van een scroll-listener: dat scheelt werk per frame.
     ------------------------------------------------------------------ */
  function initStickyBar() {
    var bar = document.querySelector('[data-norativ-stickybar]');
    if (!bar) return;

    var mainBtn = document.querySelector('.norativ-atc-button');
    if (!mainBtn) return;

    function show() {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
    function hide() {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Toon de balk zodra de hoofdknop boven beeld verdwenen is
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) show();
          else hide();
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () {
        var r = mainBtn.getBoundingClientRect();
        if (r.bottom < 0) show(); else hide();
      }, { passive: true });
    }

    // De knop in de balk klikt de echte ATC aan
    var cta = bar.querySelector('[data-norativ-stickybar-cta]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { mainBtn.click(); }, 420);
      });
    }
  }

  /* ------------------------------------------------------------------
     8.2 TABBED EXPLAINER
     ------------------------------------------------------------------ */
  function initTabs() {
    document.querySelectorAll('[data-norativ-tabs]').forEach(function (root) {
      var btns = root.querySelectorAll('.norativ-tabs__btn');
      var panels = root.querySelectorAll('.norativ-tabs__panel');
      if (!btns.length) return;

      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = btn.getAttribute('data-tab-index');

          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });

          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel-index') === idx);
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     8.3 DUAL INFO TABS
     ------------------------------------------------------------------ */
  function initDualTabs() {
    document.querySelectorAll('[data-norativ-ditabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('.norativ-di-tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     8.4 BENEFITS ACCORDION
     Eén rij tegelijk open: dat houdt de sectie kort en dwingt een keuze.
     ------------------------------------------------------------------ */
  function initBenefitsAccordion() {
    var rows = document.querySelectorAll('[data-norativ-ba-row]');
    if (!rows.length) return;

    rows.forEach(function (row) {
      var head = row.querySelector('.norativ-ba-head');
      var panel = row.querySelector('.norativ-ba-panel');
      if (!head || !panel) return;

      head.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = row.classList.contains('is-open');

        rows.forEach(function (other) {
          var p = other.querySelector('.norativ-ba-panel');
          var h = other.querySelector('.norativ-ba-head');
          if (!p) return;
          other.classList.remove('is-open');
          p.style.height = '0px';
          if (h) h.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          row.classList.add('is-open');
          panel.style.height = panel.scrollHeight + 'px';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-norativ-ba-row].is-open').forEach(function (row) {
        var p = row.querySelector('.norativ-ba-panel');
        if (p) p.style.height = p.scrollHeight + 'px';
      });
    });
  }

  /* ------------------------------------------------------------------
     8.5 RESULTS CAROUSEL
     Bouwt de stippen op basis van het echte aantal slides.
     ------------------------------------------------------------------ */
  function initResultsCarousel() {
    document.querySelectorAll('[data-norativ-rc]').forEach(function (root) {
      var track = root.querySelector('[data-norativ-rc-track]');
      var dotsWrap = root.querySelector('[data-norativ-rc-dots]');
      if (!track || !dotsWrap) return;

      var slides = track.querySelectorAll('.norativ-rc-slide');
      if (slides.length < 2) { dotsWrap.style.display = 'none'; return; }

      dotsWrap.innerHTML = '';
      var dots = [];

      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'norativ-rc-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });

      track.addEventListener('scroll', function () {
        var closest = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; closest = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------------
     8.6 LIVE VIEWERS
     Wisselt traag binnen de ingestelde bandbreedte. Bewust langzaam:
     een teller die elke seconde springt leest als nep.
     ------------------------------------------------------------------ */
  function initViewers() {
    var nodes = document.querySelectorAll('[data-norativ-viewers]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min)) min = 5;
      if (isNaN(max) || max <= min) max = min + 6;

      function pick() {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      el.textContent = pick();

      setInterval(function () {
        if (document.hidden) return;
        el.textContent = pick();
      }, 9000 + Math.random() * 5000);
    });
  }

  function initNewSections() {
    initStickyBar();
    initTabs();
    initDualTabs();
    initBenefitsAccordion();
    initResultsCarousel();
    initViewers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewSections);
  } else {
    initNewSections();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initNewSections);
  }
})();


/* ==========================================================================
   9. STICKY BAR UIT DE STAPELCONTEXT HALEN
   .norativ-pdp-wrapper heeft isolation:isolate met z-index:0. Daarmee
   geldt z-index:9000 op de sticky bar alleen BINNEN die wrapper; de
   reviews-sectie en de footer staan erbuiten en komen er dus overheen.
   Hoger stapelen helpt niet. De balk moet naar body verplaatst worden.
   ========================================================================== */

(function () {
  'use strict';

  function liftStickyBar() {
    var bar = document.querySelector('[data-norativ-stickybar]');
    if (!bar) return;
    if (bar.parentElement === document.body) return;
    document.body.appendChild(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', liftStickyBar);
  } else {
    liftStickyBar();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', liftStickyBar);
  }
})();


/* ==========================================================================
   10. GALLERY BEGINT ALTIJD BIJ DE EERSTE FOTO
   Browsers bewaren de scrollpositie van scrollbare containers en zetten
   die bij een refresh terug. Bij een horizontale gallery betekent dat
   een willekeurige foto als eerste beeld. Dat is verwarrend en het
   eerste beeld is juist het beeld dat verkoopt.

   We zetten de track expliciet terug op nul, en herhalen dat nadat de
   afbeeldingen geladen zijn, omdat de browser zijn herstel soms pas
   daarna uitvoert.
   ========================================================================== */

(function () {
  'use strict';

  function resetGalleryScroll() {
    var track = document.querySelector('.norativ-gallery-track');
    if (!track) return;

    // Alleen terugzetten als de bezoeker zelf nog niet heeft geswipet
    if (track.dataset.norativTouched === '1') return;

    track.scrollLeft = 0;

    var thumbs = document.querySelectorAll('.norativ-thumb-item');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === 0);
    });
  }

  function markTouched() {
    var track = document.querySelector('.norativ-gallery-track');
    if (track) track.dataset.norativTouched = '1';
  }

  function initGalleryReset() {
    var track = document.querySelector('.norativ-gallery-track');
    if (!track) return;

    // Zodra de bezoeker zelf scrollt of een thumb kiest, laten we los
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
      track.addEventListener(ev, markTouched, { passive: true, once: true });
    });

    document.querySelectorAll('.norativ-thumb-item').forEach(function (t) {
      t.addEventListener('click', markTouched, { once: true });
    });

    resetGalleryScroll();

    // De browser herstelt zijn scrollpositie soms pas na het laden
    // van de afbeeldingen, dus nog twee keer nalopen
    window.addEventListener('load', resetGalleryScroll);
    setTimeout(resetGalleryScroll, 120);
    setTimeout(resetGalleryScroll, 500);
  }

  // Ook bij terugnavigeren uit de bfcache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var track = document.querySelector('.norativ-gallery-track');
      if (track) delete track.dataset.norativTouched;
      resetGalleryScroll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryReset);
  } else {
    initGalleryReset();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initGalleryReset);
  }
})();